export default function TestimonialSection() {
  return (
    <section className="py-20 bg-[#FAFAF8] relative overflow-hidden">
      <div className="absolute top-10 left-10 w-32 h-32 opacity-20">
        <svg viewBox="0 0 100 100" className="w-full h-full">
          <path d="M10 50 Q 30 10 50 50 T 90 50" stroke="#D4A574" strokeWidth="2" fill="none" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-6">
        <div className="relative">
          <div className="bg-[#1A2332] rounded-[32px] p-12 lg:p-16 relative overflow-visible">
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
              <div className="lg:col-span-2 relative">
                <div className="relative lg:absolute lg:-left-24 lg:top-1/2 lg:-translate-y-1/2 w-full lg:w-80">
                  <img
                    src="https://public.readdy.ai/ai/img_res/9063afde332c706875f4290a8207ab6c.jpg"
                    alt="Maria Rodriguez - El Paso Entrepreneur"
                    className="w-full h-auto rounded-2xl shadow-2xl object-cover"
                    style={{ width: '400px', height: '500px' }}
                  />
                </div>
              </div>

              <div className="lg:col-span-3 space-y-6">
                <div className="text-[#D4A574] text-6xl font-serif leading-none">"</div>
                <p className="text-white text-2xl leading-relaxed" style={{ lineHeight: '1.6' }}>
                  The resources and guidance I found here were invaluable when starting my business in El Paso. From understanding local regulations to connecting with other entrepreneurs, everything I needed was in one place.
                </p>
                <div className="pt-4">
                  <p className="text-white font-semibold text-lg">Maria Rodriguez</p>
                  <p className="text-white/70 text-base">Founder, Southwest Tech Solutions</p>
                </div>
                <div className="pt-6">
                  <button className="bg-[#FF9B8A] text-gray-900 px-8 py-3 rounded-full font-semibold hover:bg-[#FF8A77] transition-colors cursor-pointer whitespace-nowrap">
                    Read More Success Stories
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}